<template>
    <v-pagination v-model="currentPage" :length="length" :total-visible="totalVisible" :disabled="disabled" />
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import type { PagingParam } from '../../utils/types/PagingParam';
import { shallowCopy } from '../../utils/types/utility';

@Component({
    name: 'Pagination',
})
export default class Pagination extends Vue {
    @Prop({ default: undefined }) readonly value?: PagingParam;
    @Prop({ default: undefined }) readonly disabled?: boolean;
    @Prop({ type: [String, Number], default: undefined }) readonly totalVisible: number | string;
    @Emit()
    public input(value: PagingParam) {}

    get currentPage(): number {
        if (!this.value) {
            return 0;
        }
        return this.value.currentPage;
    }
    set currentPage(val: number) {
        if (!this.value) {
            return;
        }
        let newValue = shallowCopy(this.value);
        newValue.currentPage = val;
        this.input(newValue);
    }
    get length(): number | undefined {
        if (!this.value) {
            return undefined;
        }
        return Math.ceil(this.value.total / this.value.perPage);
    }
}
</script>
